import React,{useState} from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import MCSPagedTable from '../../../components/MCSPagedTable';
import MCSLoading from '../../../components/MCSLoading';
import Icon from '@visa/vds/icon';

function AccessRequestUserTable(props){
    let colHeaders = [  
        {displayName:"Organization Name", name:"orgName",orderable: false},
        {displayName:"User Id",name:"userId",orderable: false}, 
        {displayName:"Role Name",name:"roleName",orderable: false},
        {displayName:"Email",name:"email",orderable: false},
        {displayName:"Full Name",name:"fullName",orderable: false},
        {displayName:"",name:"actions",orderable:false}
    ];

    const [selectedPage,setSelectedPage] = useState(1)

    const fetchDataOnPageChange = (page) =>{
        setSelectedPage(page);
        props.fetch(page);
    }

    if(!props.fetched){
        return(<MCSLoading/>)
    }
    else{
        return (
        <>
        <MCSPagedTable size={"compact"}
            colHeaders={colHeaders} 
            useSearchBar={false}
            usePagination={true}
            selectedPage={selectedPage} setSelectedPage={fetchDataOnPageChange}totalPages={props.totalPages}
            tableData={
                props.data && props.data.items.map((row,key)=>(
                <Tr key={key}>
                    <Td>{row.organizationName}</Td>
                    <Td>{row.userId}</Td>
                    <Td>{row.roleName}</Td>
                    <Td>{row.email}</Td>
                    <Td>{row.fullName}</Td>
                    <Td><Icon onClick={()=>props.setSelectedUser(row)} className="vss-clickable-icon" name="settings" resolution="low" /></Td>
                </Tr>
                ))
            }/>
        </>
        );
    }
  }


export default AccessRequestUserTable;
